import React from "react";
import { ArrowRight, MessageSquare, Ship } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_maritime-solutions-10/artifacts/t0xwlg3s_094E0458-3D97-4A65-AD3A-02FC17558DBB.png";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Cargo maritime moderne au port"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-gradient-overlay" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-12 pb-24 pt-40 text-white">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-12 bg-[#D90429]" />
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#D90429]">
            Avitaillement · Logistique · Commerce
          </span>
        </div>

        <h1
          data-testid="hero-title"
          className="font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-7xl max-w-4xl leading-[1.05]"
        >
          KMS{" "}
          <span className="text-[#D90429]">SERVICES</span>{" "}
          PLUS
        </h1>

        <p className="mt-6 text-lg sm:text-xl lg:text-2xl font-light max-w-2xl text-white/85 font-heading">
          Votre partenaire en avitaillement maritime, logistique et commerce
          international en Côte d'Ivoire.
        </p>

        <p className="mt-4 text-sm sm:text-base max-w-2xl text-white/65 leading-relaxed">
          Spécialiste de l'avitaillement maritime, vente de vivres, matériels,
          équipements, import-export et services logistiques.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4">
          <a href="#contact" data-testid="hero-quote-btn" className="kms-btn-light">
            Demander un devis
            <ArrowRight size={18} />
          </a>
          <a href="#contact" data-testid="hero-contact-btn" className="inline-flex items-center gap-2 text-white font-semibold border-b border-white/40 pb-1 hover:border-[#D90429] hover:text-[#D90429] transition-colors">
            <MessageSquare size={18} /> Nous contacter
          </a>
          <a href="#services" data-testid="hero-services-btn" className="inline-flex items-center gap-2 text-white font-semibold border-b border-white/40 pb-1 hover:border-[#D90429] hover:text-[#D90429] transition-colors">
            <Ship size={18} /> Nos services
          </a>
        </div>

        <div className="mt-20 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-3xl border-t border-white/20 pt-8">
          {[
            { v: "100%", l: "Fiabilité" },
            { v: "24/7", l: "Disponibilité" },
            { v: "8+", l: "Services" },
            { v: "CI", l: "Présence locale" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-heading font-black text-2xl sm:text-3xl text-white">
                {s.v}
              </div>
              <div className="text-xs uppercase tracking-widest text-white/60 mt-1">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 right-6 lg:right-12 text-white/50 text-xs uppercase tracking-[0.3em] hidden sm:block">
        Scroll ↓
      </div>
    </section>
  );
}
